import { CSSProperties, FC } from 'react';
import { AText } from '../AText';
import { Box } from '../Box';
import { StatusIcon } from '../StatusIcon';

import styles from './index.module.css';

interface FontStatusConfig {
  fontStatusSize?: 's' | 'm' | 'l';
  fontStatusWeight?: 'R' | 'B' | 'RU' | 'BU';
}

interface StatusIconWithTextProps {
  className?: string;
  status?: string;
  label?: string;
  fontStatusConfig?: FontStatusConfig;
  style?: CSSProperties;
}

export const StatusIconWithText: FC<StatusIconWithTextProps> = ({
  className = '',
  status = '',
  label = '',
  fontStatusConfig = {},
  style
}) => {
  const { fontStatusSize = 's', fontStatusWeight = 'R' } = fontStatusConfig;

  return (
    <Box align="center" className={className} style={style}>
      <StatusIcon status={status} className={styles.icon} />
      <AText
        breed={fontStatusWeight}
        size={fontStatusSize}
        color="po_txt_color_1"
      >
        {label}
      </AText>
    </Box>
  );
};
